// extracted by mini-css-extract-plugin
export default {"description":"DescriptionPara_description__XROd3"};